// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"0900a179","770":"5e0c4f05"}[chunkId] + ".chunk.js";
};